import "vant/es/image/style";
import _Image from "vant/es/image";
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ac77f55a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "head-pic"
};
const _hoisted_2 = ["src"];
import { ref } from 'vue';
export default {
  props: {
    poster: Object,
    src: String
  },

  setup(__props) {
    const props = __props;
    const face = ref('');
    const authIcon = ref('');

    if (props.src) {
      face.value = new String(props.src);
    } // 有传发帖者


    if (props.poster) {
      const poster = { ...props.poster
      };

      if (props.poster.professor == null) {
        // 平常的
        face.value = poster.photo;
      } else if (props.poster.anonymous == true) {
        // 匿名
        face.value = poster.photo;
      } else if (props.poster.professor) {
        // 专家
        const professor = { ...props.poster.professor
        }; // 有专家

        face.value = professor.face;
        authIcon.value = poster.authenticationIcon;
      }
    }

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(_Image), {
        class: "head-pic-photo",
        src: face.value,
        "error-icon": "https://fsnewsres.foshanplus.com/other/20220531/d738a4de704948d0b92d12b8ff71541e.png",
        "loading-icon": "https://fsnewsres.foshanplus.com/other/20220531/d738a4de704948d0b92d12b8ff71541e.png",
        fit: "contain",
        Lazyload: ""
      }, null, 8, ["src"]), authIcon.value && authIcon.value.length > 0 ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "head-pic-icon",
        src: authIcon.value,
        alt: ""
      }, null, 8, _hoisted_2)) : _createCommentVNode("", true)]);
    };
  }

};